import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import ListaContatos from './ListaContatos';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Admin » Contatos" />
        <Conteudo>
          <ListaContatos />
        </Conteudo>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/Contatos.js